import { useWorkspace } from '@/features/workspaces/hooks';
import { useGetAudiencesQuery } from '@/services/endpoints/audiences';

export const useFirstAudienceId = () => {
  const { id: workspaceId } = useWorkspace();
  const { data, isLoading, isFetching, isError } = useGetAudiencesQuery({ workspaceId, limit: 1 }, { skip: !workspaceId });

  const audienceId = data?.items?.[0]?.id;
  const isAudienceLoading = isLoading || isFetching;

  return {
    audienceId,
    isLoading: isAudienceLoading,
    isAudienceSettled: !isAudienceLoading,
    isError,
    hasAudience: !!audienceId,
  };
};
